import { useTranslation } from 'react-i18next';

export function useI18n () {
  const { i18n } = useTranslation();

  return {
    language: i18n.language.split('-')[0],
  };
}
